Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById('contact-block')) {
        Contact.components.contactBlock = new Vue({
            el: document.getElementById("contact-block"),
            store,
            data: function () {
                return {
                    map: null,
                    marker: null
                }
            },
            computed: {},
            mounted() {
                this.initMap();
            },
            methods: {
                initMap() {
                    // The location of Uluru
                    const office = {lat: 51.849150, lng: 4.657110};

                    this.map = new google.maps.Map(this.$refs.map, {zoom: 10, center: office});
                    this.marker = new google.maps.Marker({position: office, map: this.map});
                }
            }
        });
    }
});